module.exports = __webpack_public_path__ + "img/charts.773b883e.png";